import { render } from "./Header.vue?vue&type=template&id=f486fae0"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=f486fae0&lang=scss"

import exportComponent from "/Users/alizand/Herd/rodeo/base-project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__